import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const JobsCard = ({ job }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(prev => !prev);

  return React.createElement(
    "div",
    { className: expanded ? "job-card expanded" : "job-card" },

    // Title and Company
    React.createElement("h2", null, job.title),
    job.company && React.createElement("h3", { className: "company" }, job.company),

    // Short description
    React.createElement(
      "p",
      { className: expanded ? "job-desc expanded" : "job-desc" },
      job.description
    ),

    // Expandable details
    expanded &&
      React.createElement(
        React.Fragment,
        null,
        // Responsibilities
        job.responsibilities &&
          React.createElement(
            "div",
            { className: "job-section" },
            React.createElement("h4", null, "Responsibilities:"),
            React.createElement(
              "ul",
              null,
              job.responsibilities.map((item, i) =>
                React.createElement("li", { key: i }, item)
              )
            )
          ),

        // Requirements
        job.requirements &&
          React.createElement(
            "div",
            { className: "job-section" },
            React.createElement("h4", null, "Requirements:"),
            React.createElement(
              "ul",
              null,
              job.requirements.map((item, i) =>
                React.createElement("li", { key: i }, item)
              )
            )
          ),

        // Offer / Benefits
        job.offer &&
          React.createElement(
            "div",
            { className: "job-section" },
            React.createElement("h4", null, "What We Offer:"),
            React.createElement(
              "ul",
              null,
              job.offer.map((item, i) =>
                React.createElement("li", { key: i }, item)
              )
            )
          ),

        // Additional Info
        job.income_potential &&
          React.createElement(
            "p",
            { className: "highlight" },
            `Income Potential: ${job.income_potential}`
          )
      ),

    // Location / Type
    React.createElement("p", null, `Location: ${job.location}`),
    React.createElement("p", null, `Type: ${job.type}`),

    // Buttons
    React.createElement(
      "div",
      { className: "button-row" },
      React.createElement(
        "button",
        { className: "toggle-btn", onClick: toggleExpand },
        expanded ? "See Less" : "See More"
      ),
      React.createElement(
        "button",
        {
          className: "apply-btn",
          onClick: () => navigate(`/apply/${job.id}`)
        },
        "Apply Now"
      )
    )
  );
};
